import { db } from "../Firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

/**
 * ตรวจสอบการเข้าสู่ระบบกับ Firestore
 * @param {string} username 
 * @param {string} password 
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const verifyLogin = async (username, password) => {
  try {
    // Create a query against the collection.
    // Normalized to lowercase as per user request
    const q = query(collection(db, "Parent"), where("username", "==", username.trim().toLowerCase()));
    const querySnapshot = await getDocs(q);
    
    let loginSuccessful = false;
    let userDataFound = null;

    // Even though we query by username, we still need to check the password and handle potential multiplicity (though username should be unique)
    querySnapshot.forEach((doc) => {
      // If we found a document, it means the username matches (case-sensitive from query)
      const userData = doc.data();
      
      // Password check - kept logic similar to original but focused on this specific user
      // Note: original was case-insensitive for password too. 
      // Since we are optimizing, strict comparison might be better but let's stick to the plan's implication of "username case sensitive".
      // However, to keep password check consistent with previous "flexible" logic if desired, we can keep some flexibility, 
      // OR mostly likely, just do a direct comparison if we want full optimization.
      // Given the previous code did `normalizedPassword === dbPassword`, it suggests the DB might have mixed casing?
      // Let's assume strict comparison for password too to match the "Optimized" nature, 
      // BUT, to be safe against existing data inconsistency, I'll keep the password normalize check LOCALLY for the found user.
      
      const normalizedPassword = password.trim().toLowerCase();
      const dbPassword = (typeof userData.password === 'string' ? userData.password.trim().toLowerCase() : 
                         typeof userData.password === 'number' ? userData.password.toString().toLowerCase() : '') || '';

      if (normalizedPassword === dbPassword) {
        loginSuccessful = true;
        userDataFound = {
          ...userData, 
          username: userData.username, // Ensure username is from DB
          level: userData.level || 0,
          score: userData.score || 0,
          collection: "Parent",
          id: doc.id
        };
      }
    });

    if (loginSuccessful && userDataFound) {
      return { success: true, data: userDataFound };
    } else {
      return { success: false, error: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง" };
    }
  } catch (error) {
    console.error("Login Error:", error);
    return { success: false, error: "เกิดข้อผิดพลาดในการเชื่อมต่อ" };
  }
};
